var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.24975C8.24264 9.24975 9.25 8.2424 9.25 6.99976C9.25 5.75711 8.24264 4.74976 7 4.74976C5.75736 4.74976 4.75 5.75711 4.75 6.99976C4.75 8.2424 5.75736 9.24975 7 9.24975Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2427 11.2425L8.0605 14.4248C7.77924 14.7058 7.39794 14.8636 7.00037 14.8636C6.60281 14.8636 6.22151 14.7058 5.94025 14.4248L2.75725 11.2425C1.91817 10.4034 1.34675 9.3343 1.11527 8.17043C0.883782 7.00655 1.00262 5.80016 1.45675 4.70383C1.91089 3.60749 2.67992 2.67043 3.66661 2.01116C4.6533 1.35189 5.81333 1 7 1C8.18667 1 9.3467 1.35189 10.3334 2.01116C11.3201 2.67043 12.0891 3.60749 12.5432 4.70383C12.9974 5.80016 13.1162 7.00655 12.8847 8.17043C12.6532 9.3343 12.0818 10.4034 11.2427 11.2425V11.2425Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/Address.99bef28c.svg";
export { ForwardRef as ReactComponent };